import {
  Component,
  Input,
  CUSTOM_ELEMENTS_SCHEMA,
  Output,
  EventEmitter,
} from '@angular/core';
import type { LeafCheckboxFieldItem } from '@cigna/leaf-web/lib/wc';
import '@cigna/leaf-web/lib/wc/components/checkbox-field-item/checkbox-field-item';

@Component({
  selector: 'cigna-leaf-checkbox-field-item',
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  template: `
    <leaf-checkbox-field-item
      [ariaDescribedBy]="ariaDescribedBy"
      [checked]="checked"
      [disabled]="disabled"
      [errorNote]="isError ? errorNote : undefined"
      [errorText]="errorText"
      [fieldId]="fieldId"
      [isError]="isError"
      [isSuccess]="isSuccess"
      [label]="label"
      [name]="name"
      [required]="required"
      [successNote]="isSuccess ? successNote : undefined"
      [successText]="successText"
      [value]="value"
      [validationAriaDescribedBy]="validationAriaDescribedBy"
      [isOptional]="isOptional"
      [optionalText]="optionalText"
      (change)="handleChange($event.target.checked, $event); onChange($event)"
    >
    </leaf-checkbox-field-item>
  `,
})
export class CignaLeafCheckboxFieldItemComponent {
  @Input() ariaDescribedBy: LeafCheckboxFieldItem['ariaDescribedBy'];
  @Input() checked: LeafCheckboxFieldItem['checked'];
  @Input() disabled: LeafCheckboxFieldItem['disabled'];
  @Input() errorNote: LeafCheckboxFieldItem['errorNote'];
  @Input() errorText: LeafCheckboxFieldItem['errorText'];
  @Input() fieldId: LeafCheckboxFieldItem['fieldId'];
  @Input() fieldNote: LeafCheckboxFieldItem['fieldNote'];
  @Input() isError: LeafCheckboxFieldItem['isError'];
  @Input() isSuccess: LeafCheckboxFieldItem['isSuccess'];
  @Input() label: LeafCheckboxFieldItem['label'] = '';
  @Input() name: LeafCheckboxFieldItem['name'];
  @Input() required: LeafCheckboxFieldItem['required'];
  @Input() successNote: LeafCheckboxFieldItem['successNote'];
  @Input() successText: LeafCheckboxFieldItem['successText'];
  @Input() value: LeafCheckboxFieldItem['value'];
  @Input()
  validationAriaDescribedBy: LeafCheckboxFieldItem['validationAriaDescribedBy'];
  @Input() isOptional: LeafCheckboxFieldItem['isOptional'] = false;
  @Input() optionalText: LeafCheckboxFieldItem['optionalText'] = '';

  /**
   * ********
   * CUSTOM ANGULAR PROPERTIES
   */
  @Output() change = new EventEmitter<boolean>();

  onChange(event: Event) {
    event.stopPropagation();
  }

  handleChange(checked: boolean, event?: Event) {
    this.change.emit(checked);
  }
}
